import script from "./RecommendedProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./RecommendedProducts.vue?vue&type=script&setup=true&lang=js"

import "./RecommendedProducts.vue?vue&type=style&index=0&id=0f28ed26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f28ed26"]])

export default __exports__